import React from 'react';
import PropTypes from 'prop-types';

import FooterUpsell from 'components/FooterUpsell';

import CoverImage from './components/CoverImage';
import Details from './components/Details';
import Activities from './components/Activities';
import MonthlyStats from './components/MonthlyStats';
import Trophies from './components/Trophies';
import Achievements from './components/Achievements';

import styles from './styles.scss';

const AthleteProfileApp = ({
  athlete,
  recentActivities,
  trophies,
  stats,
  authUrls,
  achievements,
  analyticsData,
  deeplink
}) => (
  <main role="main">
    <CoverImage />

    <div className={`${styles.container} container`}>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-3 ${styles.athlete}`}>
          <Details athlete={athlete} />
        </div>

        <div className={`col-md-6 ${styles.activities}`}>
          <Activities athlete={athlete} activities={recentActivities} />
        </div>

        <div className={`col-md-3 ${styles.metrics}`}>
          <div className={styles.section}>
            <MonthlyStats stats={stats} />
          </div>
          <div className={styles.section}>
            <Trophies
              trophies={trophies}
              athleteName={athlete.name}
              followUrl={athlete.followUrl}
            />
          </div>
          <div className={styles.section}>
            <Achievements achievements={achievements} />
          </div>
        </div>
      </div>
    </div>

    <FooterUpsell
      authUrls={authUrls}
      analyticsData={analyticsData}
      deeplink={deeplink}
    />
  </main>
);

AthleteProfileApp.defaultProps = {
  recentActivities: null,
  stats: {
    montlyTime: '',
    monthlyDistance: '',
    chartData: []
  }
};

AthleteProfileApp.propTypes = {
  athlete: PropTypes.shape({
    name: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string.isRequired,
    primarySport: PropTypes.string.isRequired,
    followersCount: PropTypes.number.isRequired,
    followingCount: PropTypes.number.isRequired,
    followUrl: PropTypes.string.isRequired
  }).isRequired,
  recentActivities: PropTypes.arrayOf(PropTypes.object),
  trophies: PropTypes.arrayOf(PropTypes.object).isRequired,
  stats: PropTypes.shape({
    monthlyTime: PropTypes.string,
    monthlyDistance: PropTypes.string,
    chartData: PropTypes.arrayOf(PropTypes.object)
  }),
  authUrls: PropTypes.shape({}).isRequired,
  achievements: PropTypes.arrayOf(PropTypes.object).isRequired,
  analyticsData: PropTypes.shape().isRequired,
  deeplink: PropTypes.string.isRequired
};

export default AthleteProfileApp;
